import { Template } from "@/models";
import { useEffect, useState } from "react";
import {
  FetchUserAttributesOutput,
  fetchUserAttributes,
} from "aws-amplify/auth";
import { GraphQLQuery, generateClient } from "aws-amplify/api";
import { sortByDate, sortByUpdatedAt } from "@/utils/utils";
import { templatesByLIDAndUpdatedAt } from "@/graphql/queries";
import {
  ModelSortDirection,
  TemplatesByLIDAndUpdatedAtQuery,
  TemplatesByLIDAndUpdatedAtQueryVariables,
} from "@/API";

const useTemplates = () => {
  const client = generateClient();
  const [templates, setTemplates] = useState<Template[]>([]);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    fetchTemplates();
  }, []);

  async function fetchTemplates() {
    setRefreshing(true);
    try {
      const userAttr: FetchUserAttributesOutput = await fetchUserAttributes();
      const templatesQueryInput: TemplatesByLIDAndUpdatedAtQueryVariables = {
        lID: userAttr["custom:location"]!,
        sortDirection: ModelSortDirection.DESC,
        limit: 1000,
        filter: {
          _deleted: { ne: true },
          archived: { ne: true },
        },
      };
      const templatesData: any = await client.graphql<
        GraphQLQuery<TemplatesByLIDAndUpdatedAtQuery>
      >({ query: templatesByLIDAndUpdatedAt, variables: templatesQueryInput });
      const templatesList =
        templatesData.data.templatesByLIDAndUpdatedAt!.items;
      const templatesSortUpdated = getMaxUpdatedTemplate(templatesList);
      setTemplates(templatesSortUpdated.sort(sortByUpdatedAt));
    } catch (err) {
      console.warn(err);
    }
    setRefreshing(false);
  }

  const getMaxUpdatedTemplate = (templates: any) => {
    return templates?.map((template: any) => {
      const lstDate = [template.updatedAt];

      template?.sections?.items?.map((section: any) => {
        lstDate.push(section.updatedAt);
      });
      template?.subsections?.items?.map((subsection: any) => {
        lstDate.push(subsection.updatedAt);
      });
      template?.fields?.items?.map((field: any) => {
        lstDate.push(field.updatedAt);
      });
      template?.textboxes?.items?.map((textbox: any) => {
        lstDate.push(textbox.updatedAt);
      });
      const dateSorted = lstDate.sort(sortByDate);
      template.updatedAt = dateSorted[0];
      return template;
    });
  };
  return { templates, refreshing, fetchTemplates };
};

export default useTemplates;
